import React from 'react';
import './css/Videos.css';


const Videos = () => {
    return (
        
        <div className="row">
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="500">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">Right Cause Nonprofit Solution</h5>
                        <p className="card-text">Automate day-to-day processes to foster donor relationships, track and manage Fundraising Activities, Grant Management, Program Delivery, Volunteer Management and Reporting.</p>
                        <br />
                        <a href="https://youtu.be/j8g5v9GpakQ" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-duration="1000">
                <div className="card tabCards">
                    <div className="card-body">
                        <h5 className="card-title blueTxt">Right Cause Grant Management Solution</h5>
                        <p className="card-text">A comprehensive Grants Management Solution built on secure Microsoft Dynamics 365 platform.</p>
                        <a href="https://youtu.be/Yby8S1ytbd4" target="_blank" className="card-link"><span className="icon-arrow"></span></a>
                    </div>
                </div>
            </div>
            </div> 
            
    )
}

export default Videos